import { render } from "./JobRegisterView.vue?vue&type=template&id=a0096520&scoped=true"
import script from "./JobRegisterView.vue?vue&type=script&lang=js"
export * from "./JobRegisterView.vue?vue&type=script&lang=js"

import "@/assets/css/jobReg.css?vue&type=style&index=0&id=a0096520&lang=css&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0096520"]])

export default __exports__